import { ReactPlugin, useTrackEvent  } from '@microsoft/applicationinsights-react-js'

const reactPlugin = new ReactPlugin()

export default reactPlugin
